import { dcFactory } from 'dc';
import ServiceEditor from './js/service-editor.component';
import ServiceAccessRequestForm from './js/service-access-request-form.component';
import ServiceDeletionRequestForm from './js/service-deletion-request-form.component';

dcFactory.register(ServiceEditor);
dcFactory.register(ServiceAccessRequestForm);
dcFactory.register(ServiceDeletionRequestForm);
